/* eslint-disable no-shadow */
export enum syncStatusEnum {
  synched = 1,
  notSynched,
  noInfo
}

export enum ControllerConnectionStatesEnum {
  CONNECTED = 5,
  DISCONNECTED = 6,
  UNKNOWN = 7
}

export enum WIFI_SIGNAL {
  POOR = 'Poor',
  GOOD = 'Good',
  EXCELLENT = 'Excellent',
  NO_SIGNAL = 'No Signal',
  UNKNOWN = 'Unknown'
}
